<template>
    <div class="myGoods">
        <keep-alive include="goodsList">
            <router-view :hostroletype="hostroletype"></router-view>
        </keep-alive>
    </div>
</template>

<script>
  export default {
    name: 'myGoods',
    data() {
      return {
          hostroletype: 4
      }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .myGoods {
    }
</style>
